import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { ReferralsSettings } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class ReferralsSettingsEntityHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadReferralsSettings(): Observable<ReferralsSettings> {
    return this.httpApi.get(`/referral/program`).pipe(map(data => data.program));
  }

  public updateReferralsSettings(
    referralsSettings: Partial<ReferralsSettings>,
  ): Observable<ReferralsSettings> {
    return this.httpApi
      .patch(`/referral/program`, null, referralsSettings)
      .pipe(map(data => data.program));
  }

  public toggleReferralProgram({ enabled }: { enabled: boolean }): Observable<ReferralsSettings> {
    return this.httpApi
      .patch(`/referral/program/toggle`, null, { program: { enabled } })
      .pipe(map(data => data.program));
  }
}
